import React from 'react'
import style from './SpinnerWhite.module.css'

const SpinnerWhite = () => {
  return (
      <div className={style.spinner}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
  )
}

export default SpinnerWhite